import NotFound from '../components/NotFound';
import React from 'react';
import Footer from "../components/Footer";

const NotFoundPage: React.FC = () => {
	return (
		<>
			<NotFound />
			<Footer />
		</>

	);
};

export default NotFoundPage;
